import { FileStack } from 'lucide-react';

export const TripartiteAgreementNotice = () => (
  <div className="flex gap-4 p-5 rounded-xl border border-accent-software-escrow bg-[color-mix(in_srgb,var(--color-accent-software-escrow)_6%,var(--color-white))] shadow-sm">
    <div className="size-10 rounded-md bg-accent-software-escrow flex items-center justify-center shrink-0">
      <FileStack className="size-5 text-white" />
    </div>
    <div className="space-y-1">
      <h3 className="text-base font-extrabold text-foreground">Tripartite agreement → Beneficiary IS involved</h3>
      <p className="text-sm text-muted-foreground">
        We’ll generate a tripartite agreement signed by the depositor, the beneficiary, and the escrow agent. This will
        outline each party’s responsibilities in full.
      </p>
    </div>
  </div>
);
